var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#A1A1A1",
    className: "app-icon"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.334 20.3938L24.0866 26L28 10L8 17.535L14.0858 19.4657L25.1924 12.3301L16.334 20.3938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0858 19.4657L15.6508 26L16.334 20.3938L25.1925 12.3301L14.0858 19.4657Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 22.4267L15.6508 26L16.334 20.3938L19.1719 22.4267Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTelegram);
export default __webpack_public_path__ + "static/media/footer_telegram.f71e16ec08a3e68f49230cdd0b2c4ed6.svg";
export { ForwardRef as ReactComponent };